const maxDeviceLimit = {
  DEFAULT: 6,
  SETAPP: 8,
};

export { maxDeviceLimit };
